import { useDebouncedCallback } from '@bob/library'
import React, { useEffect, useRef, useState } from 'react'

export function useVisibleRange(initialVisible = false) {
  const _startcursorRef = useRef<HTMLDivElement>(null)
  const _endcursorRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(initialVisible)

  const StartCursor = () => <div data-testid={'start-cursor'} ref={_startcursorRef} />
  const EndCursor = () => <div data-testid={'end-cursor'} ref={_endcursorRef} />

  const calculate = () => {
    let startCursorOutOfScreen = true

    if (_startcursorRef.current) {
      const startTop = _startcursorRef.current.getBoundingClientRect().top
      startCursorOutOfScreen = startTop < 0
    }

    let endCursorIsOnScreen = true

    if (_endcursorRef.current) {
      const endTop = _endcursorRef.current.getBoundingClientRect().top
      endCursorIsOnScreen = endTop - window.innerHeight < 0
    }

    const dVisible = startCursorOutOfScreen && !endCursorIsOnScreen

    if (dVisible !== isVisible) {
      setIsVisible(dVisible)
    }
  }

  const handleScroll = useDebouncedCallback(calculate, 30)

  useEffect(() => {
    calculate()
    document.addEventListener('scroll', handleScroll)

    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  })

  return {
    StartCursor,
    EndCursor,
    isVisible,
  }
}
